import { t } from "ttag";

import { useShopContext } from "@/features/products/context";
import { CATEGORY_COLOR } from "@/features/products/models";
import type { CategoryWithProducts } from "@/features/products/models";
import { Chip, ScrollArea } from "@/shared/ui";

interface CategoriesFilterProps {
  categories: CategoryWithProducts[];
}

export const CategoriesFilter = ({ categories }: CategoriesFilterProps) => {
  const {
    selectedCategory,
    actions: { setSelectedCategory },
  } = useShopContext();

  return (
    <ScrollArea orientation="horizontal">
      <div className="flex justify-center-safe gap-2.5 [&_*]:shrink-0">
        <Chip
          size="large"
          color={!selectedCategory ? "dark-primary" : "light-primary"}
          onClick={() => setSelectedCategory(null)}
        >
          {t`All`}
        </Chip>

        {categories?.map(({ id, name, slug }) => {
          return (
            <Chip
              key={id}
              size="large"
              color={CATEGORY_COLOR[slug]}
              outline={slug !== selectedCategory}
              onClick={() => setSelectedCategory(slug)}
            >
              {name}
            </Chip>
          );
        })}
      </div>
    </ScrollArea>
  );
};
